// DO NOT EDIT MANUALLY! Autogenerated by pnpm codegen
import type * as Types from '~/gql/jobs/types.generated';

import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import type * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export const JobFieldsFragmentDoc = gql`
    fragment jobFields on Job {
  id
  title
  description
  applicationInstructions
  companyName
  publishedAt
  isHot
  draft
  expired
  expiryAt
  applicationUrl
  applicationEmail
  companyLogoThumb
  jobTypes
  experiences
  startAt
  categories {
    id
    slug
  }
  offerType
  features
  street
  city
  zipcode
  country
  salaryFrom
  salaryTo
  myomrUserId
  locations {
    id
    name
    placeIdGoogle
  }
  locationOptions
}
    `;
export const SearchFacetFragmentDoc = gql`
    fragment searchFacet on Facet {
  facetId
  name
  count
}
    `;
export const UserFieldsFragmentDoc = gql`
    fragment userFields on User {
  id
  profileId
  userProperties {
    firstName
    lastName
    position
    jobLevel
    companyName
    companySize
    companyDepartment
    companyIndustryId
    companyFieldId
    omrMatchConsent
    email
  }
  jobSearchStatus
  location {
    id
    name
    placeIdGoogle
  }
  willingToRelocate
  locationOptions
  categories {
    id
    slug
  }
}
    `;
export const CreateJobDocument = gql`
    mutation CreateJob($attributes: JobAttributes!) {
  createJob(attributes: $attributes) {
    job {
      id
    }
    errors
  }
}
    `;

/**
 * __useCreateJobMutation__
 *
 * To run a mutation, you first call `useCreateJobMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateJobMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateJobMutation({
 *   variables: {
 *     attributes: // value for 'attributes'
 *   },
 * });
 */
export function useCreateJobMutation(options: VueApolloComposable.UseMutationOptions<Types.CreateJobMutation, Types.CreateJobMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.CreateJobMutation, Types.CreateJobMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.CreateJobMutation, Types.CreateJobMutationVariables>(CreateJobDocument, options);
}
export type CreateJobMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.CreateJobMutation, Types.CreateJobMutationVariables>;
export const FindOrCreateLocationDocument = gql`
    mutation FindOrCreateLocation($name: String!, $placeIdGoogle: String!) {
  findOrCreateLocation(name: $name, placeIdGoogle: $placeIdGoogle) {
    location {
      id
      name
      placeIdGoogle
    }
    errors
  }
}
    `;

/**
 * __useFindOrCreateLocationMutation__
 *
 * To run a mutation, you first call `useFindOrCreateLocationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useFindOrCreateLocationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useFindOrCreateLocationMutation({
 *   variables: {
 *     name: // value for 'name'
 *     placeIdGoogle: // value for 'placeIdGoogle'
 *   },
 * });
 */
export function useFindOrCreateLocationMutation(options: VueApolloComposable.UseMutationOptions<Types.FindOrCreateLocationMutation, Types.FindOrCreateLocationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.FindOrCreateLocationMutation, Types.FindOrCreateLocationMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.FindOrCreateLocationMutation, Types.FindOrCreateLocationMutationVariables>(FindOrCreateLocationDocument, options);
}
export type FindOrCreateLocationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.FindOrCreateLocationMutation, Types.FindOrCreateLocationMutationVariables>;
export const UpdateJobDocument = gql`
    mutation UpdateJob($id: ID!, $attributes: JobAttributes!) {
  updateJob(id: $id, attributes: $attributes) {
    job {
      ...jobFields
    }
    errors
  }
}
    ${JobFieldsFragmentDoc}`;

/**
 * __useUpdateJobMutation__
 *
 * To run a mutation, you first call `useUpdateJobMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateJobMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateJobMutation({
 *   variables: {
 *     id: // value for 'id'
 *     attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpdateJobMutation(options: VueApolloComposable.UseMutationOptions<Types.UpdateJobMutation, Types.UpdateJobMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.UpdateJobMutation, Types.UpdateJobMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.UpdateJobMutation, Types.UpdateJobMutationVariables>(UpdateJobDocument, options);
}
export type UpdateJobMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.UpdateJobMutation, Types.UpdateJobMutationVariables>;
export const UpdateUserDocument = gql`
    mutation UpdateUser($attributes: UserUpdateInput!, $userId: ID!) {
  updateUser(userId: $userId, attributes: $attributes) {
    user {
      ...userFields
    }
    errors
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateUserMutation({
 *   variables: {
 *     attributes: // value for 'attributes'
 *     userId: // value for 'userId'
 *   },
 * });
 */
export function useUpdateUserMutation(options: VueApolloComposable.UseMutationOptions<Types.UpdateUserMutation, Types.UpdateUserMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.UpdateUserMutation, Types.UpdateUserMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.UpdateUserMutation, Types.UpdateUserMutationVariables>(UpdateUserDocument, options);
}
export type UpdateUserMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.UpdateUserMutation, Types.UpdateUserMutationVariables>;
export const FindJobDocument = gql`
    query findJob($id: ID!) {
  jobDetails(id: $id) {
    ...jobFields
  }
}
    ${JobFieldsFragmentDoc}`;

/**
 * __useFindJobQuery__
 *
 * To run a query within a Vue component, call `useFindJobQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindJobQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFindJobQuery({
 *   id: // value for 'id'
 * });
 */
export function useFindJobQuery(variables: Types.FindJobQueryVariables | VueCompositionApi.Ref<Types.FindJobQueryVariables> | ReactiveFunction<Types.FindJobQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.FindJobQuery, Types.FindJobQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.FindJobQuery, Types.FindJobQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.FindJobQuery, Types.FindJobQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.FindJobQuery, Types.FindJobQueryVariables>(FindJobDocument, variables, options);
}
export function useFindJobLazyQuery(variables?: Types.FindJobQueryVariables | VueCompositionApi.Ref<Types.FindJobQueryVariables> | ReactiveFunction<Types.FindJobQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.FindJobQuery, Types.FindJobQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.FindJobQuery, Types.FindJobQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.FindJobQuery, Types.FindJobQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.FindJobQuery, Types.FindJobQueryVariables>(FindJobDocument, variables, options);
}
export type FindJobQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.FindJobQuery, Types.FindJobQueryVariables>;
export const GetCategoriesDocument = gql`
    query getCategories {
  jobsCategories {
    id
    slug
  }
}
    `;

/**
 * __useGetCategoriesQuery__
 *
 * To run a query within a Vue component, call `useGetCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCategoriesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCategoriesQuery();
 */
export function useGetCategoriesQuery(options: VueApolloComposable.UseQueryOptions<Types.GetCategoriesQuery, Types.GetCategoriesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetCategoriesQuery, Types.GetCategoriesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetCategoriesQuery, Types.GetCategoriesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetCategoriesQuery, Types.GetCategoriesQueryVariables>(GetCategoriesDocument, {}, options);
}
export function useGetCategoriesLazyQuery(options: VueApolloComposable.UseQueryOptions<Types.GetCategoriesQuery, Types.GetCategoriesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetCategoriesQuery, Types.GetCategoriesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetCategoriesQuery, Types.GetCategoriesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetCategoriesQuery, Types.GetCategoriesQueryVariables>(GetCategoriesDocument, {}, options);
}
export type GetCategoriesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetCategoriesQuery, Types.GetCategoriesQueryVariables>;
export const GetFeaturesDocument = gql`
    query getFeatures {
  features {
    nettoPrice
    slug
  }
}
    `;

/**
 * __useGetFeaturesQuery__
 *
 * To run a query within a Vue component, call `useGetFeaturesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeaturesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetFeaturesQuery();
 */
export function useGetFeaturesQuery(options: VueApolloComposable.UseQueryOptions<Types.GetFeaturesQuery, Types.GetFeaturesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetFeaturesQuery, Types.GetFeaturesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetFeaturesQuery, Types.GetFeaturesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetFeaturesQuery, Types.GetFeaturesQueryVariables>(GetFeaturesDocument, {}, options);
}
export function useGetFeaturesLazyQuery(options: VueApolloComposable.UseQueryOptions<Types.GetFeaturesQuery, Types.GetFeaturesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetFeaturesQuery, Types.GetFeaturesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetFeaturesQuery, Types.GetFeaturesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetFeaturesQuery, Types.GetFeaturesQueryVariables>(GetFeaturesDocument, {}, options);
}
export type GetFeaturesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetFeaturesQuery, Types.GetFeaturesQueryVariables>;
export const GetPriceDocument = gql`
    query getPrice($offerType: ID!, $features: [ID!]) {
  calculate(offerType: $offerType, features: $features) {
    price
    currency
    currencySymbol
  }
}
    `;

/**
 * __useGetPriceQuery__
 *
 * To run a query within a Vue component, call `useGetPriceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPriceQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetPriceQuery({
 *   offerType: // value for 'offerType'
 *   features: // value for 'features'
 * });
 */
export function useGetPriceQuery(variables: Types.GetPriceQueryVariables | VueCompositionApi.Ref<Types.GetPriceQueryVariables> | ReactiveFunction<Types.GetPriceQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetPriceQuery, Types.GetPriceQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetPriceQuery, Types.GetPriceQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetPriceQuery, Types.GetPriceQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetPriceQuery, Types.GetPriceQueryVariables>(GetPriceDocument, variables, options);
}
export function useGetPriceLazyQuery(variables?: Types.GetPriceQueryVariables | VueCompositionApi.Ref<Types.GetPriceQueryVariables> | ReactiveFunction<Types.GetPriceQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetPriceQuery, Types.GetPriceQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetPriceQuery, Types.GetPriceQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetPriceQuery, Types.GetPriceQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetPriceQuery, Types.GetPriceQueryVariables>(GetPriceDocument, variables, options);
}
export type GetPriceQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetPriceQuery, Types.GetPriceQueryVariables>;
export const GetMeDocument = gql`
    query getMe {
  me {
    ...userFields
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useGetMeQuery__
 *
 * To run a query within a Vue component, call `useGetMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMeQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetMeQuery();
 */
export function useGetMeQuery(options: VueApolloComposable.UseQueryOptions<Types.GetMeQuery, Types.GetMeQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetMeQuery, Types.GetMeQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetMeQuery, Types.GetMeQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetMeQuery, Types.GetMeQueryVariables>(GetMeDocument, {}, options);
}
export function useGetMeLazyQuery(options: VueApolloComposable.UseQueryOptions<Types.GetMeQuery, Types.GetMeQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetMeQuery, Types.GetMeQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetMeQuery, Types.GetMeQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetMeQuery, Types.GetMeQueryVariables>(GetMeDocument, {}, options);
}
export type GetMeQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetMeQuery, Types.GetMeQueryVariables>;
export const GetPricingDocument = gql`
    query getPricing {
  pricing {
    standard
    internship
    basic
    full
  }
}
    `;

/**
 * __useGetPricingQuery__
 *
 * To run a query within a Vue component, call `useGetPricingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPricingQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetPricingQuery();
 */
export function useGetPricingQuery(options: VueApolloComposable.UseQueryOptions<Types.GetPricingQuery, Types.GetPricingQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetPricingQuery, Types.GetPricingQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetPricingQuery, Types.GetPricingQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetPricingQuery, Types.GetPricingQueryVariables>(GetPricingDocument, {}, options);
}
export function useGetPricingLazyQuery(options: VueApolloComposable.UseQueryOptions<Types.GetPricingQuery, Types.GetPricingQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetPricingQuery, Types.GetPricingQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetPricingQuery, Types.GetPricingQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetPricingQuery, Types.GetPricingQueryVariables>(GetPricingDocument, {}, options);
}
export type GetPricingQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetPricingQuery, Types.GetPricingQueryVariables>;
export const GetPromoCodeDocument = gql`
    query getPromoCode($name: String!) {
  promoCode(name: $name) {
    id
    name
    discountPercentage
  }
}
    `;

/**
 * __useGetPromoCodeQuery__
 *
 * To run a query within a Vue component, call `useGetPromoCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPromoCodeQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetPromoCodeQuery({
 *   name: // value for 'name'
 * });
 */
export function useGetPromoCodeQuery(variables: Types.GetPromoCodeQueryVariables | VueCompositionApi.Ref<Types.GetPromoCodeQueryVariables> | ReactiveFunction<Types.GetPromoCodeQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetPromoCodeQuery, Types.GetPromoCodeQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetPromoCodeQuery, Types.GetPromoCodeQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetPromoCodeQuery, Types.GetPromoCodeQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetPromoCodeQuery, Types.GetPromoCodeQueryVariables>(GetPromoCodeDocument, variables, options);
}
export function useGetPromoCodeLazyQuery(variables?: Types.GetPromoCodeQueryVariables | VueCompositionApi.Ref<Types.GetPromoCodeQueryVariables> | ReactiveFunction<Types.GetPromoCodeQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetPromoCodeQuery, Types.GetPromoCodeQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetPromoCodeQuery, Types.GetPromoCodeQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetPromoCodeQuery, Types.GetPromoCodeQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetPromoCodeQuery, Types.GetPromoCodeQueryVariables>(GetPromoCodeDocument, variables, options);
}
export type GetPromoCodeQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetPromoCodeQuery, Types.GetPromoCodeQueryVariables>;
export const SearchJobsDocument = gql`
    query searchJobs($page: Int!, $categories: [ID!], $locations: [ID!], $experiences: [ID!], $locationOptions: [ID!]) {
  searchJobs(
    page: $page
    categories: $categories
    locations: $locations
    experiences: $experiences
    locationOptions: $locationOptions
  ) {
    jobs {
      id
      title
      companyName
      startAt
      publishedAt
      isHot
      companyLogoThumb
      locations {
        name
      }
      locationOptions
    }
    categoryFacets {
      ...searchFacet
    }
    locationFacets {
      ...searchFacet
    }
    experienceFacets {
      ...searchFacet
    }
    locationOptionFacets {
      ...searchFacet
    }
    jobCount
    perPage
  }
}
    ${SearchFacetFragmentDoc}`;

/**
 * __useSearchJobsQuery__
 *
 * To run a query within a Vue component, call `useSearchJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchJobsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSearchJobsQuery({
 *   page: // value for 'page'
 *   categories: // value for 'categories'
 *   locations: // value for 'locations'
 *   experiences: // value for 'experiences'
 *   locationOptions: // value for 'locationOptions'
 * });
 */
export function useSearchJobsQuery(variables: Types.SearchJobsQueryVariables | VueCompositionApi.Ref<Types.SearchJobsQueryVariables> | ReactiveFunction<Types.SearchJobsQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.SearchJobsQuery, Types.SearchJobsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.SearchJobsQuery, Types.SearchJobsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.SearchJobsQuery, Types.SearchJobsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.SearchJobsQuery, Types.SearchJobsQueryVariables>(SearchJobsDocument, variables, options);
}
export function useSearchJobsLazyQuery(variables?: Types.SearchJobsQueryVariables | VueCompositionApi.Ref<Types.SearchJobsQueryVariables> | ReactiveFunction<Types.SearchJobsQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.SearchJobsQuery, Types.SearchJobsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.SearchJobsQuery, Types.SearchJobsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.SearchJobsQuery, Types.SearchJobsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.SearchJobsQuery, Types.SearchJobsQueryVariables>(SearchJobsDocument, variables, options);
}
export type SearchJobsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.SearchJobsQuery, Types.SearchJobsQueryVariables>;